import {sum} from 'BenchlingUtil';
import {
  AnalyticsVisualizationAggregationType as AggregationType,
  AnalyticsVisualizationErrorBarType as ErrorBarType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {mean, standardDeviation, standardError} from 'ui-library/charting/statistics/StatUtils';

/**
 * Maps AggregationType to necessary updates to functions that calculate the aggregation of given values
 */
export const AGGREGATION_TYPE_TO_FUNCTION: {
  [key in AggregationType]: (values: Array<number>) => number;
} = {
  [AggregationType.COUNT]: (values: Array<number>) => values.length,
  [AggregationType.MEAN]: (values: Array<number>) => mean(values),
  [AggregationType.SUM]: (values: Array<number>) => sum(values),
};

/**
 * Maps ErrorBarType to necessary updates to functions that calculate the error bar aggregation of given values
 */
export const ERROR_BAR_TYPE_TO_ERROR_VALUE_FUNCTION: {
  [key in ErrorBarType]: (values: Array<number>) => number | null;
} = {
  [ErrorBarType.STANDARD_DEVIATION]: (values: Array<number>) =>
    values.length > 1 ? standardDeviation(values) : null,
  [ErrorBarType.STANDARD_ERROR]: (values: Array<number>) =>
    values.length > 1 ? standardError(values) : null,
};

/**
 * The abbreviated label for error bar values to display in, e.g., chart tooltips.
 * See ERROR_BAR_TYPE_TO_READABLE for the full names.
 */
export const ERROR_BAR_TYPE_TO_LABEL: {[key in ErrorBarType]: string} = {
  [ErrorBarType.STANDARD_DEVIATION]: 'SD',
  [ErrorBarType.STANDARD_ERROR]: 'SE',
};
